var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", { staticClass: "case-card" }, [
    _c(
      "a",
      { staticClass: "case-card__inner", attrs: { href: _vm.caseItem.Url } },
      [
        _vm.caseItem.Image
          ? _c("ResponsiveImage", {
              attrs: {
                wrapperClass: "case-card__image",
                imageModel: _vm.caseItem.Image,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        !_vm.caseItem.Image
          ? _c("div", { staticClass: "case-card__image" }, [_vm._m(0)])
          : _vm._e(),
        _vm._v(" "),
        _c("p", { staticClass: "case-card__tag" }, [
          _vm._v(
            "\n            " + _vm._s(_vm.caseItem.CustomerName) + "\n        "
          ),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "case-card__name" }, [
          _vm._v("\n            " + _vm._s(_vm.caseItem.Name) + "\n        "),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "image-cover-wrap" }, [
      _c("picture", [
        _c("img", {
          staticClass: "image-cover lazyload",
          attrs: {
            width: "620",
            height: "380",
            src: "/assets/images/placeholders/case_card_placeholder.png",
            alt: "",
          },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }